import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import styles from './Journal.scss'
import { JOURNAL_USERID } from '../App'
import { journalMessages } from '../intlMessages'
import { HeaderImg } from '../shared/HeaderImg'
import { rideReportActions, rideReportSelectors } from 'data/resources/rideReports'
import { Loadable } from 'common/Loadable'
import { Card } from 'common/styleguide/Card'
import { SingleLineEditor } from 'common/SingleLineEditor'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { Msg, featureNames } from 'lib/localization'
import { urls } from 'lib/urls'
import { FormattedMessage as T, injectIntl } from 'react-intl'
import moment from 'moment'
import Helmet from 'react-helmet'

import header from './images/journal-header.jpg'

class _Journal extends React.PureComponent {
  render () {
    const { articles } = this.props

    return (
      <StandardLayout>
        <T {...featureNames.journal}>
          {title => <Helmet title={`${title} · Ride with GPS`} />}
        </T>
        <HeaderImg
          headingAlt={<Msg m={featureNames.journal} />}
          headerText={<T id='journalMessages.headerText' defaultMessage='Scenes from the Saddle' />}
          position='bottom'
          src={header} />

        <Articles articles={articles} />
      </StandardLayout>
    )
  }
}

const Articles = ({ articles }) => {
  const isIE = !!window.MSInputMethodContext && !!document.documentMode
  return articles.size > 0
    ? <div className={styles.articles}>
      {articles.valueSeq().sortBy(a => -moment(a.publishedAt).format('x')).map(a => <ArticleCard key={a.id} article={a} isIE={isIE} />)}
    </div>
    : <div> empty </div>
}

const ArticleCard = withRouter(({ article, isIE, history }) => {
  const articlePath = `/journal/${article.slug}`
  const openArticle = () => {
    history.push(articlePath)
  }
  return (
    <Card noPadding className={styles.articleCard}>
      {isIE
        ? <div onClick={openArticle} className={styles.imageWrapper} style={{ backgroundImage: `url(${urls.photos.large(article.featuredImageId)})` }} />
        : <img onClick={openArticle} className={styles.articleImg} src={urls.photos.large(article.featuredImageId)} />}
      <div className={styles.lower}>
        <Link to={articlePath} className={styles.title}>{article.title}</Link>
        <div className={styles.subtitle}>
          <SingleLineEditor
            defaultValue={article.subtitle}
            textAlignment='left'
            readOnly
            type='subtitle'
          />
        </div>
      </div>
    </Card>
  )
})

const loadInitialData = ({ loadJournal }) => {
  return Promise.all([loadJournal()])
}

const LoadableJournal = (props) => <Loadable
  {...props}
  component={_Journal}
  loadingText={<Msg m={journalMessages.loading} />}
  resourceLoaded={() => loadInitialData(props)} />

export const IntlJournal = injectIntl(LoadableJournal)

export const Journal = connect(
  state => ({ articles: rideReportSelectors.byUserId(state, JOURNAL_USERID) }),
  { loadJournal: rideReportActions.journal }
)(IntlJournal)
